import angular from 'angular';

export default angular
  .module('app.filters.hyphen-inflector', [])
  .filter('hyphenInflector', $filter => input =>
    input
      .replace(/-(\s)*/g, '-')
      .replace(/-([a-z])/g, char => char.toUpperCase())
  );
